import { get } from 'lodash';
import template from './new-building-sale-type.jade';
import validation from './../../../services/validation';
import unfinishedNewBuildingSaleType from '../../../enums/unfinished-new-building-sale-type';
import { cplNewbuildingSaleTypes } from '../../../enums/cpl-new-building-sale-type';
import { getUserTariff } from '../../../../../../shared/utils';
import { selectAnalyticsOfferStatus } from '../../../../../../shared/selectors/analytics';
import { trackRequiredFieldFill } from '../../../../../../shared/utils/tracking/requiredFields';

export default angular
  .module('cian.addForm.newBuildingSaleType', [])
  .directive('cianAfPriceAndDealTermsNewBuildingSaleType', () => ({
    scope: {},
    bindToController: {
      ad: '=',
      form: '=',
    },
    controller: [
      'popupService',
      '$scope',
      'config',
      'deviceService',
      'store',
      function (popupService, $scope, config, deviceService, store) {
        this.isMobile = deviceService.isMobile;

        if (!this.ad.building) {
          this.ad.building = {};
        }

        const setSaleTypeValues = () => {
          this.areCplSaleTypesEnabled = Boolean(config.get('addForm.CplSaleTypesVisible.Enabled'));
          this.areCplSaleTypesVisible = this.areCplSaleTypesEnabled && this.isAgentCPLMode;

          this.unfinishedNewBuildingSaleType = this.areCplSaleTypesVisible
            ? cplNewbuildingSaleTypes
            : unfinishedNewBuildingSaleType;
        };

        this.sendMessage = () => {
          popupService.openPopup('reportError');
        };

        this.validation = validation(this.form, 'bargainTermsSaleType', {
          required: 'Укажите тип продажи',
        });

        const getAgentCPLMode = (addFormState, jk) => {
          const { isAgentCPLExperiment } = addFormState;
          const { user } = store.getState();
          const { isBuilder } = getUserTariff(user);

          const isCPLNewbuilding = get(jk, 'cplEnabled', false);

          return (
            Boolean(isAgentCPLExperiment) && // установлен х-заголовок x-cpl-agent
            isCPLNewbuilding && // выбранный ЖК есть в списке ЖК, для которых включен эксперимент "CPL для агентов"
            (!isBuilder || !addFormState.user) // юзер не авторизован или не застройщик
          );
        };

        this.isAgentCPLMode = getAgentCPLMode(window.addFormState, this.ad.geo.jk);
        this.defaultValue = this.isAgentCPLMode ? 'dupt' : null;

        this.handleChange = () => {
          const state = store.getState();
          const category = selectAnalyticsOfferStatus(state);

          trackRequiredFieldFill(category, 'sales_type');
        };

        setSaleTypeValues();

        $scope.$watch(
          () => this.ad.geo.jk,
          newJK => {
            if (newJK && newJK.id) {
              this.isAgentCPLMode = getAgentCPLMode(window.addFormState, newJK);
              setSaleTypeValues();
              const isValidSaleType =
                this.areCplSaleTypesEnabled &&
                this.unfinishedNewBuildingSaleType.some(({ key }) => this.ad.bargainTerms.saleType === key);

              if (this.isAgentCPLMode && !isValidSaleType) {
                this.ad.bargainTerms.saleType = 'dupt';
              }
            }
          },
        );
      },
    ],
    controllerAs: 'newBuildingSaleType',
    template,
  })).name;
